import ky from 'ky';

const getToken = (): string | null => {
  try {
    const stored = localStorage.getItem('pbf-portal-auth');
    return stored ? (JSON.parse(stored)?.state?.token ?? null) : null;
  } catch {
    return null;
  }
};

const apiClient = ky.create({
  prefixUrl: import.meta.env.VITE_PORTAL_API_URL,
  hooks: {
    beforeRequest: [
      (request) => {
        const token = getToken();
        if (token) request.headers.set('Authorization', `Bearer ${token}`);
      },
    ],
    afterResponse: [
      (request, _options, response) => {
        if (response.status === 401 && !request.url.includes('/auth/login')) {
          localStorage.removeItem('pbf-portal-auth');
          window.location.href = '/login';
        }
        return response;
      },
    ],
  },
});

export default apiClient;
